import buildGqlQuery, { myf2b_fetcher } from './buildGqlQuery';

export default {
	access: buildGqlQuery(
		'curriculum_access',
		{ id: 'String!' },
		`auth { curriculum(visibility: false, id: $id) }`,
		myf2b_fetcher,
	),
	visibility: buildGqlQuery(
		'curriculum_visibility',
		{ id: 'String!' },
		`auth { curriculum(visibility: true, id: $id) }`,
		myf2b_fetcher,
	),
};
